import React, { useRef, useEffect, useState } from "react";
import "./GenericTableRow.css";
import ComingSoon from "../../BenchmarkDetails/Nudges/comingSoonComp";

const GenericTableRow = ({ row, columns }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [hasOverflow, setHasOverflow] = useState(false);
  const contentRefs = useRef([]);

  useEffect(() => {
    const anyOverflow = contentRefs.current.some(
      (el) => el && el.scrollWidth > el.clientWidth
    );
    setHasOverflow(anyOverflow);
  }, [row]);

  const handleToggleExpand = (e, tdData) => {
    e.preventDefault();
    e.stopPropagation();
    if (tdData?.expandable) {
      setIsExpanded((prev) => !prev);
      tdData?.onClickAction?.(tdData);
    }
  };

  if (row?.isPartialLoad) {
    return (
      <tr className="gtr-expanded-row">
      {row?.isPartialLoad}
      </tr>
    );
  }

  return (
    <>
      <tr
        className={`gtr-row ${isExpanded ? "gtr-expanded" : ""}`}
        style={{ cursor: hasOverflow ? "pointer" : "default" }}
      >
        {columns.map((col, idx) => {
          if (col.isTimeLine) {
            return (
              <td
                className="timeline-cell"
                key="timestamp"
                style={{ minWidth: col.width, maxWidth: col.width }}
              >
                <div className="timeline-track">
                  <div className="timeline-line top" />
                  <div className="timeline-dot"> {row[col?.id]}</div>

                  <div className="timeline-line bottom" />
                </div>
              </td>
            );
          }

          return (
            <td
              key={col.id}
              style={{ minWidth: col.width, maxWidth: col.width }}
              className={`gtr-cell ${row.is_read === false && idx==0 ? "gtr-unread" : ""}`}
        
              onClick={(e) => handleToggleExpand(e, row[col.id])}
            >
              <div className="gtr-cell-content-container">
                <div
                  ref={(el) => (contentRefs.current[idx] = el)}
                  className={`gtr-cell-content ${isExpanded ? "gtr-full" : ""}`}
                >
                  {row[col.id]?.content ?? row[col.id]}
                </div>
                {row[col.id]?.expandable && (
                  <span>
                    <img
                      src={
                        isExpanded
                          ? "/img/contractRow.svg"
                          : "/img/expandRow.svg"
                      }
                      alt="toggle"
                    />
                  </span>
                )}
              </div>
            </td>
          );
        })}
      </tr>
      {isExpanded && row.isExpandedContent}
    </>
  );
};

export default GenericTableRow;
